import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="lots--bulk-import-mapping"
//
// Keeps the inline "example values" line under each column dropdown in sync
// with the currently-selected column, and hides the area-unit picker when the
// user chooses to compute the area from the map (blank area column).
export default class extends Controller {
  static values = {
    samples: Object,
    noSamples: String,
    samplesPrefix: String
  }

  static targets = ["areaUnit"]

  // change->lots--bulk-import-mapping#updateSamples
  updateSamples(event) {
    const select = event.target
    const field = select.closest("[data-mapping-field]")
    const display = field?.querySelector("[data-mapping-samples]")
    if (!display) return

    const column = select.value
    if (column) {
      const samples = this.samplesValue[column] || this.noSamplesValue
      display.textContent = `${this.samplesPrefixValue} ${samples}`.trim()
    } else {
      display.textContent = ""
    }
  }

  // change->lots--bulk-import-mapping#toggleAreaUnit
  toggleAreaUnit(event) {
    if (!this.hasAreaUnitTarget) return
    this.areaUnitTarget.classList.toggle("hidden", event.target.value === "")
  }
}
